import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UpgradeContractModalComponent } from './upgrade-contract-modal.component';
import { UpgradeContractModalData, UpgradeContractModalResult } from './upgrade-contract-modal.types';

@Injectable({
  providedIn: 'root'
})
export class UpgradeContractModalService {
  constructor(
    private modal: NzModalService,
    private translate: TranslateService
  ) {}

  open(data: UpgradeContractModalData): Observable<UpgradeContractModalResult | null> {
    const modalRef = this.modal.create<UpgradeContractModalComponent, UpgradeContractModalData, UpgradeContractModalResult | null>({
      nzContent: UpgradeContractModalComponent,
      nzData: data,
      nzTitle: this.translate.instant(
        data.source === 'branded_domain'
          ? 'UPGRADE_CONTRACT_MODAL.BRANDED_DOMAIN.TITLE'
          : 'UPGRADE_CONTRACT_MODAL.TITLE'
      ),
      nzFooter: null,
      nzWidth: 860,
      nzClosable: data.source === 'branded_domain',
      nzMaskClosable: false,
    });

    return modalRef.afterClose.pipe(map((result) => result ?? null));
  }
}
